/*
 * @Author: yi
 * @Date: 2023-11-13 14:49:01
 * @LastEditors: yi
 * @LastEditTime: 2023-12-04 11:08:53
 * @Description: file content
 */
import React from 'react'
import  styled  from 'styled-components'
import Logo from '../../assets/images/img_logo.png'

export default function Header() {
  return (
    <Wrapper  className='lg:h-[44px] xl:h-[76px]  xl:px-[117px] xl:py-[24px] lg:py-[7px] lg:px-[50px] h-[44px] md:h-[44px] px-[15px]  md:px-[15px] py-[7px] md:py-[7px]'>
        <a href="https://borderfree.app/">
            <LogoWrapper className='w-[189px] h-[30px]'>
                <img src={Logo} alt="borderfree" />
            </LogoWrapper>
        </a>
    </Wrapper>
  )
}

const Wrapper = styled.div`
    width: 100%;
    background: #FCFCFC;
    backdrop-filter: blur(4px);
    box-sizing:border-box;
`
const LogoWrapper = styled.div`
    width: 189px;
    height: 30px;
    > img {
        width: 100%;
        height:100%;
    }
`